/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createAlumniSurveyRequest } from '../models/api_createAlumniSurveyRequest';
import type { api_createAlumniSurveyResponse } from '../models/api_createAlumniSurveyResponse';
import type { api_getAlumniSurveyResponsePrefillCheveningResponse } from '../models/api_getAlumniSurveyResponsePrefillCheveningResponse';
import type { api_getAlumniSurveyResponseResponse } from '../models/api_getAlumniSurveyResponseResponse';
import type { api_getSurveyResponseResponse } from '../models/api_getSurveyResponseResponse';
import type { api_sendAlumniSurveyTokenEmailRequest } from '../models/api_sendAlumniSurveyTokenEmailRequest';
import type { api_submitAlumniSurveyResponseCheveningRequest } from '../models/api_submitAlumniSurveyResponseCheveningRequest';
import type { api_submitAlumniSurveyResponseRequest } from '../models/api_submitAlumniSurveyResponseRequest';
import type { api_submitEligibilitySurveyResponseResponse } from '../models/api_submitEligibilitySurveyResponseResponse';
import type { api_submitSurveyResponseRequest } from '../models/api_submitSurveyResponseRequest';
import type { api_updateAlumniSurveyResponseCheveningRequest } from '../models/api_updateAlumniSurveyResponseCheveningRequest';
import type { api_updateAlumniSurveyResponseRequest } from '../models/api_updateAlumniSurveyResponseRequest';
import type { api_validateAlumniSurveyTokenResponse } from '../models/api_validateAlumniSurveyTokenResponse';
import type { api_validateSurveyResponseTokenResponse } from '../models/api_validateSurveyResponseTokenResponse';
import type { db_GetQuestionRow } from '../models/db_GetQuestionRow';
import type { db_GetSurveyResponseQuestionsAndAnswersRow } from '../models/db_GetSurveyResponseQuestionsAndAnswersRow';
import type { db_GetSurveyRow } from '../models/db_GetSurveyRow';
import type { db_ListQuestionsBySurveyIDRow } from '../models/db_ListQuestionsBySurveyIDRow';
import type { db_ListSurveyResponseQuestionsRow } from '../models/db_ListSurveyResponseQuestionsRow';
import type { db_ListSurveysRow } from '../models/db_ListSurveysRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Surveys {
    /**
     * Create an alumni survey
     * @param body Alumni survey details
     * @returns api_createAlumniSurveyResponse Created
     * @throws ApiError
     */
    public static createAlumniSurvey(
        body: api_createAlumniSurveyRequest,
    ): CancelablePromise<api_createAlumniSurveyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/alumni-surveys',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an alumni survey response
     * @param body Alumni survey response
     * @returns any Created
     * @throws ApiError
     */
    public static updateAlumniSurveyResponse(
        body: api_updateAlumniSurveyResponseRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/alumni-surveys',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a Chevening "Stay Connected" alumni survey response's review decisions
     * @param body Alumni survey review decisions
     * @returns any Created
     * @throws ApiError
     */
    public static updateAlumniSurveyResponseChevening(
        body: api_updateAlumniSurveyResponseCheveningRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/alumni-surveys/chevening',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit an alumni survey response
     * @param body Alumni survey response
     * @returns any Created
     * @throws ApiError
     */
    public static submitAlumniSurveyResponse(
        body: api_submitAlumniSurveyResponseRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/alumni-surveys/response',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit a Chevening "Stay Connected" alumni survey response
     * @param body Alumni survey response
     * @returns any Created
     * @throws ApiError
     */
    public static submitAlumniSurveyResponseChevening(
        body: api_submitAlumniSurveyResponseCheveningRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/alumni-surveys/response/chevening',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get which conditional Chevening alumni survey questions to show and the country of residence on record
     * @returns api_getAlumniSurveyResponsePrefillCheveningResponse OK
     * @throws ApiError
     */
    public static getAlumniSurveyResponsePrefillChevening(): CancelablePromise<api_getAlumniSurveyResponsePrefillCheveningResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/alumni-surveys/response/chevening/prefill',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request a new verification email for an alumni survey
     * @param body Alumni Survey ID, Email
     * @returns void
     * @throws ApiError
     */
    public static sendAlumniSurveyTokenEmail(
        body: api_sendAlumniSurveyTokenEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/alumni-surveys/send-verification-email',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an alumni survey response
     * @param id Alumni Survey ID
     * @returns api_getAlumniSurveyResponseResponse OK
     * @throws ApiError
     */
    public static getAlumniSurveyResponse(
        id: number,
    ): CancelablePromise<api_getAlumniSurveyResponseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/alumni-surveys/{id}/response',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate an alumni survey token
     * @param id Alumni Survey ID
     * @param token Alumni Survey Token
     * @returns api_validateAlumniSurveyTokenResponse OK
     * @throws ApiError
     */
    public static validateAlumniSurveyToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateAlumniSurveyTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/alumni-surveys/{id}/validate-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a survey question
     * @param id Question ID
     * @returns db_GetQuestionRow OK
     * @throws ApiError
     */
    public static getQuestion(
        id: number,
    ): CancelablePromise<db_GetQuestionRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey-questions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a survey response
     * @param id Survey Response ID
     * @returns api_getSurveyResponseResponse OK
     * @throws ApiError
     */
    public static getSurveyResponse(
        id: number,
    ): CancelablePromise<api_getSurveyResponseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey-responses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit a survey response
     * @param id Survey Response ID
     * @param body Survey response
     * @returns any Created
     * @throws ApiError
     */
    public static submitSurveyResponse(
        id: number,
        body: api_submitSurveyResponseRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey-responses/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a survey response token
     * @param id Survey Response ID
     * @param token Survey Response Token
     * @returns api_validateSurveyResponseTokenResponse OK
     * @throws ApiError
     */
    public static validateSurveyResponseToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateSurveyResponseTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey-responses/{id}/validate-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of surveys
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListSurveysRow OK
     * @throws ApiError
     */
    public static listSurveys(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListSurveysRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of survey response questions
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListSurveyResponseQuestionsRow OK
     * @throws ApiError
     */
    public static listSurveyResponseQuestions(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListSurveyResponseQuestionsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys/questions/responses',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a survey record
     * @param id Survey ID
     * @returns db_GetSurveyRow OK
     * @throws ApiError
     */
    public static getSurvey(
        id: number,
    ): CancelablePromise<db_GetSurveyRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a survey response questions and answers
     * @param id Survey Response ID
     * @returns db_GetSurveyResponseQuestionsAndAnswersRow OK
     * @throws ApiError
     */
    public static getSurveyResponseQuestionsAndAnswers(
        id: number,
    ): CancelablePromise<Array<db_GetSurveyResponseQuestionsAndAnswersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys/{id}/answers',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an eligibility survey
     * @param id Survey ID
     * @returns api_getSurveyResponseResponse OK
     * @throws ApiError
     */
    public static getEligibilitySurvey(
        id: number,
    ): CancelablePromise<api_getSurveyResponseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys/{id}/eligibility',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit an eligibility survey response
     * @param id Survey ID
     * @param body Survey response
     * @returns api_submitEligibilitySurveyResponseResponse OK
     * @throws ApiError
     */
    public static submitEligibilitySurveyResponse(
        id: number,
        body: api_submitSurveyResponseRequest,
    ): CancelablePromise<api_submitEligibilitySurveyResponseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveys/{id}/eligibility',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get survey questions by survey ID
     * @param id Survey ID
     * @returns db_ListQuestionsBySurveyIDRow OK
     * @throws ApiError
     */
    public static getSurveyQuestionsBySurveyId(
        id: number,
    ): CancelablePromise<Array<db_ListQuestionsBySurveyIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveys/{id}/questions',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
